import Main from "@/views/Main.vue";
import crm from './modules/crm';
import trace from './modules/trace';
import buyershop from './modules/buyershop';
import dataCheck from './modules/dataCheck';
import exchange from './modules/exchange';
import mapping from './modules/mapping';
import merchant from './modules/merchant';
import operationMiddle from './modules/operationMiddle';
import seller from './modules/seller';
import specialCounter from './modules/specialCounter';
import discount from './modules/discount';
import faq from './modules/faq';
import incomplete from './modules/incomplete';
import aftersale from './modules/aftersale';
import wholesaleOrder from './modules/wholesaleOrder';
import settlement from './modules/settlement';
import size from './modules/size';

// 作为Main组件的子页面展示并且在左侧菜单显示的路由写在appRouter里
export let appRouter = [
  {
    path: "",
    icon: "key",
    // title: "Home",
    name: "home",
    component: Main,
    children: [
      {
        path: "home",
        title: "Home",
        name: "home-index",
        component: resolve => {
          require(["@/views/home/home.vue"], resolve);
        }
      }
    ]
  },
  ...crm,
  ...trace,
  ...buyershop,
  ...dataCheck,
  ...exchange,
  ...mapping,
  ...merchant,
  ...operationMiddle,
  ...seller,
  ...specialCounter,
  ...discount,
  ...faq,
  ...incomplete,
  ...aftersale,
  ...wholesaleOrder,
  ...settlement,
  ...size,
];

// 所有上面定义的路由都要写在下面的routers里
export const routes = [
  ...appRouter,
  // {
  //   path: "*",
  //   name: "NotFound",
  //   component: () => import("../views/home/404.vue")
  // }
];
